// extracted by mini-css-extract-plugin
module.exports = {"Container":"SectionTwo_Container__g2uR9","Title":"SectionTwo_Title__tsCPV","FlexBoxes":"SectionTwo_FlexBoxes__zLHPR"};